import api from '../services/api';

/**
 * Start Stripe Checkout for the 60-day free trial (card required).
 * Billing after trial is assigned automatically based on resume count.
 */
export async function startTrialCheckout() {
  const priceId =
    process.env.REACT_APP_STRIPE_PRO_PRICE_ID || process.env.REACT_APP_STRIPE_PRICE_ID;

  const { data } = await api.post('/stripe/create-checkout-session', {
    plan: 'pro',
    trialDays: 60,
    ...(priceId ? { priceId } : {}),
  });

  if (!data?.url) {
    throw new Error('Checkout URL missing from server response');
  }

  window.location.href = data.url;
  return true;
}

export function shouldCollectCardForRole(role) {
  return role === 'single' || role === 'parent';
}
